import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'
import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

import SubFolderSelector from 'modules/documents/components/Folders/FolderSelector'
import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { sortFoldersByName } from 'modules/documents/lib/Folders'
import { SPACES } from 'modules/documents/lib/constants'
import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import { useValidationsProvider } from 'modules/processes/components/ItemWizard/Providers/validations'
import { useTaskWizard } from 'modules/processes/components/ItemWizard/Tasks/TaskProvider'

interface FolderSelectorProps {
  readonly?: boolean
  description?: string
}
const FolderSelector = ({ readonly, description }: FolderSelectorProps) => {
  const { setTaskConfiguration } = useTaskWizard()
  const { itemType } = useItemProvider()
  const { setPreviewValues } = usePreviewProvider()
  const { associatedTaskItem: item, form } = useFormProvider()

  const { setFieldValidation, removeFieldValidation } = useValidationsProvider()

  const { loading, folders } = useGetFolders({ space: SPACES.EMPLOYEE_MY_DOCUMENTS, active: true })

  const currentTaskConfiguration = form.get('task_type_configuration')?.value

  const currentFolderId = currentTaskConfiguration?.folder_id

  const sortedFolders = sortFoldersByName(folders)

  const initialFolder = sortedFolders.find((folder) => folder.id === currentFolderId)

  const setPreviewFolder = (previewFolderId?: number) => {
    setPreviewValues((prevValues) => {
      return { ...prevValues, name: folders.find((folder) => folder.id === previewFolderId)?.name }
    })
  }

  const setFolderId = (folderId?: number) => {
    setTaskConfiguration({ folder_id: folderId })
    setPreviewFolder(folderId)
  }

  useEffect(() => {
    if (item?.taskTypeConfiguration) {
      setPreviewFolder(JSON.parse(item?.taskTypeConfiguration).folder_id)
    }
  }, [folders])

  useEffect(() => {
    if (currentTaskConfiguration?.folder_id) setFolderId(currentTaskConfiguration?.folder_id)
  }, [itemType])

  useEffect(() => {
    setFieldValidation({
      field: 'task_type_configuration.folder_id',
      validation: () => currentFolderId !== undefined,
    })

    return () => {
      removeFieldValidation('task_type_configuration.folder_id')
    }
  }, [currentFolderId])

  if (item && !form.values.task_type_configuration) return null

  return (
    <Box>
      {loading ? (
        <Loading />
      ) : (
        <LabeledInput
          isLegend
          mandatory
          label={
            description ||
            i18n.t(
              'processes.process_settings.tasks.form.super_tasks_module.upload_document.selector'
            )
          }
          value={currentFolderId ? String(currentFolderId) : undefined}
        >
          <SubFolderSelector
            noneOption={false}
            folders={sortedFolders}
            initialFolder={initialFolder}
            onChange={(folderId) => setFolderId(folderId || undefined)}
            readOnly={readonly ? readonly : false}
          />
        </LabeledInput>
      )}
    </Box>
  )
}

export default FolderSelector
